import React from "react";
import { Helmet } from 'react-helmet';

const Seo = (props: any) => {

    return (
        <Helmet>
            {
                props.singleData?.meta_title && <title>{props.singleData.meta_title}</title>
            }
            {
                props.singleData?.meta_description && <meta name="description" content={props.singleData.meta_description} />
            }
            {
                props.singleData?.meta_keywords && <meta name="keywords" content={props.singleData.meta_keywords} />
            }
        </Helmet>
    )
}
export default Seo;